<template>
  <img
    v-if="!isEmptyImage"
    :src="defaultSrc"
    :srcset="srcSet"
  >
</template>

<script>
import { isEmpty } from 'lodash';

export default {
  name: 'content-image',

  props: {
    image: {
      type: Object,
      default: () => {},
    },
    src: {
      type: String,
    },
  },

  computed: {
    isEmptyImage() {
      return isEmpty(this.image) && isEmpty(this.src);
    },

    defaultSrc() {
      if (!isEmpty(this.image)) return this.image.large_url;
      return this.src;
    },

    srcSet() {
      if (!isEmpty(this.image)) {
        return [
          `${this.image.large_url} 1x`,
          `${this.image.image_url} 2x`,
        ].join(',');
      }

      return '';
    },
  },
};
</script>
